// extracted by mini-css-extract-plugin
export default {"sectionWrapper":"qp-z","outfitFeedbackSection":"rp-z"};